<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (link of navLinks; track link.path) { @if (hasPermission(link.permission)) {
  <a
    mat-tab-link
    [routerLink]="link.path"
    routerLinkActive
    [routerLinkActiveOptions]="{ exact: !!link.exact }"
    #rla="routerLinkActive"
    [active]="rla.isActive"
    [attr.data-testid]="'tab-' + link.path.replace('./', '')"
  >
    {{ link.label | translate | uppercase }}
  </a>
  } }
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
